const headerData = [
  {
    prop: "id",
    label: "序号",
    columnwidth: 50,
  },
  {
    prop: "InvClassName", 
    label: "产品线",
    columnwidth: 100,
  },
  {
    prop: "JanRatio",
    label: "一月分摊比例",
    columnwidth: 130,
  },
  {
    prop: "FebRatio",
    label: "二月分摊比例",
    columnwidth: 130,
  },
  {
    prop: "MarRatio", 
    label: "三月分摊比例",
    columnwidth: 130,
  },
  {
    prop: "AprRatio", 
    label: "四月分摊比例",
    columnwidth: 130,
  },
  {
    prop: "MayRatio", 
    label: "五月分摊比例",
    columnwidth: 130,
  },
  {
    prop: "JunRatio", 
    label: "六月分摊比例",
    columnwidth: 130,
  },
  {
    prop: "JulRatio",
    label: "七月分摊比例",
    columnwidth: 130,
  },
  {
    prop: "AugRatio",
    label: "八月分摊比例",
    columnwidth: 130,
  },
  {
    prop: "SepRatio",
    label: "九月分摊比例",
    columnwidth: 130,
  },
  {
    prop: "OctRatio",
    label: "十月分摊比例",
    columnwidth: 130,
  },
  {
    prop: "NovRatio",
    label: "十一月分摊比例",
    columnwidth: 130,
  },
  {
    prop: "DecRatio",
    label: "十二月分摊比例",
    columnwidth: 130,
  },
  {
    prop: "Creator",
    label: "创建人账号",
    columnwidth: 130,
  },
  {
    prop: "CreatorName",
    label: "创建人",
    columnwidth: 130,
  },
  {
    prop: "CreateTime",
    label: "创建时间",
    columnwidth: 130,
  },
  {
    prop: "Updater",
    label: "修改人账号",
    columnwidth: 130,
  },
  {
    prop: "UpdaterName",
    label: "修改人",
    columnwidth: 130,
  },
  {
    prop: "UpdateTime",
    label: "修改时间",
    columnwidth: 130,
  },
];
export default headerData
